/** Namespace `patients` (Liste + Detail) — befüllt während der Migration. */
export const patients = {
  de: {
    patients: {
      list: {
        eyebrow: 'Patientenakte',
        title: 'Patienten',
        description: 'Zentrale Übersicht aller Patienten mit Stammdaten, Terminen und Anamnese-Status',
        active: 'aktiv',
        withIntake: 'mit Anamnese',
        newPatient: 'Neuer Patient',
        promptName: 'Name des neuen Patienten (Walk-In):',
        promptPhone: 'Telefonnummer (optional):',
        created: 'Patient {{number}} angelegt',
        errorCreate: 'Anlegen fehlgeschlagen',
        errorLoad: 'Patienten konnten nicht geladen werden',
        searchLabel: 'Suche (Name, E-Mail, Telefon, NIE, Stadt)',
        searchPlaceholder: 'z. B. Müller, maria@…, +34 600…',
        intake: 'Anamnese',
        intakeAll: 'Alle',
        intakeWith: 'Mit Anamnese',
        intakeWithout: 'Ohne Anamnese',
        language: 'Sprache',
        langAll: 'Alle',
        statusLabel: 'Status',
        statusActive: 'Aktiv',
        statusArchived: 'Archiviert',
        statusAll: 'Alle',
        resetFilters: 'Filter zurücksetzen',
        loading: 'Lade…',
        emptyNoHitsTitle: 'Keine Treffer',
        emptyNoPatientsTitle: 'Noch keine Patienten',
        emptyNoHitsDescription: 'Keine Patienten entsprechen den aktuellen Filtern.',
        emptyNoPatientsDescription: 'Sobald Buchungen eingehen oder du manuell anlegst, erscheinen Patienten hier.',
        colPatient: 'Patient',
        colContact: 'Kontakt',
        colAppointments: 'Termine',
        colIntake: 'Anamnese',
        colAction: 'Aktion',
        archived: 'archiviert',
        noEmail: 'keine E-Mail',
        last: 'zuletzt',
        intakeFilled: 'Ausgefüllt',
        intakeOpen: 'Offen',
        intakeBadge: 'Anamnese',
        appointmentsCount: '{{count}} Termine',
        open: 'Öffnen →',
        langDe: 'Deutsch',
        langEn: 'English',
        langEs: 'Español',
        langRu: 'Русский',
      },
      detail: {
        loading: 'Lade…',
        backToList: 'Zurück zur Liste',
        notFound: 'Patient nicht gefunden',
        errorLoad: 'Patient konnte nicht geladen werden',
        patientFallback: 'Patient',
        archived: 'Archiviert',
        active: 'Aktiv',
        saving: 'Speichere…',
        save: 'Speichern',
        reactivate: 'Reaktivieren',
        archive: 'Archivieren',
        savedToast: 'Stammdaten gespeichert',
        errorSave: 'Speichern fehlgeschlagen',
        confirmArchive: 'Patient {{name}} archivieren? Termine bleiben erhalten.',
        archivedToast: 'Patient archiviert',
        errorArchive: 'Archivieren fehlgeschlagen',
        reactivatedToast: 'Patient reaktiviert',
        errorReactivate: 'Reaktivieren fehlgeschlagen',
        confirmMerge: 'Diesen Patienten ({{name}}, {{number}}) IN den anderen ({{target}}) verschmelzen?\n\nDieser Datensatz wird archiviert, alle Termine wandern um.',
        mergeOk: 'Merge ok — {{appointments}} Termine umgehängt, Anamnese: {{intake}}',
        mergeIntakeNone: 'keine',
        errorMerge: 'Merge fehlgeschlagen',
        errorPdf: 'PDF konnte nicht geladen werden',
        masterData: 'Stammdaten',
        fullName: 'Voller Name',
        language: 'Sprache',
        langDe: 'Deutsch',
        langEn: 'English',
        langEs: 'Español',
        langRu: 'Русский',
        email: 'E-Mail',
        emailPlaceholder: 'optional bei Walk-In',
        phonePrimary: 'Telefon (primär)',
        phoneSecondary: 'Telefon (sekundär)',
        dateOfBirth: 'Geburtsdatum (YYYY-MM-DD)',
        placeOfBirth: 'Geburtsort',
        nie: 'NIE',
        occupation: 'Beruf',
        street: 'Straße',
        postalCode: 'PLZ',
        city: 'Stadt',
        country: 'Land (ISO, z.B. ES)',
        insurance: 'Versicherung',
        familyDoctor: 'Hausarzt',
        doctorName: 'Name',
        doctorAddress: 'Adresse',
        doctorPhone: 'Telefon',
        internalNotes: 'Interne Notizen',
        internalNotesPlaceholder: 'Sichtbar nur im Admin — z.B. besondere Hinweise zum Patienten',
        possibleDuplicates: 'Mögliche Duplikate ({{count}})',
        duplicatesHint: 'Diese Patienten teilen Namen oder Telefonnummer. Prüfe und merge ggf., damit alle Termine an einem Datensatz hängen.',
        mergeIntoThisTitle: 'Diesen Patienten in {{name}} verschmelzen',
        mergeIntoThis: 'In diesen mergen',
        appointments: 'Termine ({{count}})',
        noAppointments: 'Noch keine Termine.',
        timelineBooked: 'Gebucht',
        timelineRescheduled: 'Umgebucht',
        timelineCancelled: 'Abgesagt',
        actorPatient: 'durch Patient',
        actorPractice: 'durch Praxis',
        treatmentHistory: 'Behandlungsverlauf',
        documents: 'Belege ({{count}})',
        offer: 'Angebot',
        invoice: 'Rechnung',
        noDocuments: 'Noch keine Belege.',
        draft: 'Entwurf',
        due: 'fällig',
        appointmentRef: 'Termin #{{id}}',
        openPdf: 'PDF öffnen',
        intake: 'Anamnese',
        intakeFilled: 'Ausgefüllt',
        intakeSubmittedAt: 'eingereicht {{date}}',
        toFormAndPdf: 'Zum Bogen + PDF',
        noIntake: 'Noch kein Anamnesebogen eingereicht.',
      },
    },
  },
  es: {
    patients: {
      list: {
        eyebrow: 'Historia clínica',
        title: 'Pacientes',
        description: 'Vista central de todos los pacientes con datos maestros, citas y estado del cuestionario',
        active: 'activos',
        withIntake: 'con cuestionario',
        newPatient: 'Nuevo paciente',
        promptName: 'Nombre del nuevo paciente (Walk-In):',
        promptPhone: 'Número de teléfono (opcional):',
        created: 'Paciente {{number}} creado',
        errorCreate: 'Error al crear',
        errorLoad: 'No se pudieron cargar los pacientes',
        searchLabel: 'Búsqueda (nombre, correo, teléfono, NIE, ciudad)',
        searchPlaceholder: 'p. ej., Müller, maria@…, +34 600…',
        intake: 'Cuestionario',
        intakeAll: 'Todos',
        intakeWith: 'Con cuestionario',
        intakeWithout: 'Sin cuestionario',
        language: 'Idioma',
        langAll: 'Todos',
        statusLabel: 'Estado',
        statusActive: 'Activo',
        statusArchived: 'Archivado',
        statusAll: 'Todos',
        resetFilters: 'Restablecer filtros',
        loading: 'Cargando…',
        emptyNoHitsTitle: 'Sin resultados',
        emptyNoPatientsTitle: 'Aún no hay pacientes',
        emptyNoHitsDescription: 'Ningún paciente coincide con los filtros actuales.',
        emptyNoPatientsDescription: 'En cuanto lleguen reservas o cree uno manualmente, los pacientes aparecerán aquí.',
        colPatient: 'Paciente',
        colContact: 'Contacto',
        colAppointments: 'Citas',
        colIntake: 'Cuestionario',
        colAction: 'Acción',
        archived: 'archivado',
        noEmail: 'sin correo',
        last: 'última',
        intakeFilled: 'Completado',
        intakeOpen: 'Pendiente',
        intakeBadge: 'Cuestionario',
        appointmentsCount: '{{count}} citas',
        open: 'Abrir →',
        langDe: 'Alemán',
        langEn: 'Inglés',
        langEs: 'Español',
        langRu: 'Ruso',
      },
      detail: {
        loading: 'Cargando…',
        backToList: 'Volver a la lista',
        notFound: 'Paciente no encontrado',
        errorLoad: 'No se pudo cargar el paciente',
        patientFallback: 'Paciente',
        archived: 'Archivado',
        active: 'Activo',
        saving: 'Guardando…',
        save: 'Guardar',
        reactivate: 'Reactivar',
        archive: 'Archivar',
        savedToast: 'Datos maestros guardados',
        errorSave: 'Error al guardar',
        confirmArchive: '¿Archivar al paciente {{name}}? Las citas se conservan.',
        archivedToast: 'Paciente archivado',
        errorArchive: 'Error al archivar',
        reactivatedToast: 'Paciente reactivado',
        errorReactivate: 'Error al reactivar',
        confirmMerge: '¿Fusionar este paciente ({{name}}, {{number}}) EN el otro ({{target}})?\n\nEste registro se archivará y todas las citas se trasladarán.',
        mergeOk: 'Fusión correcta — {{appointments}} citas trasladadas, cuestionario: {{intake}}',
        mergeIntakeNone: 'ninguno',
        errorMerge: 'Error al fusionar',
        errorPdf: 'No se pudo cargar el PDF',
        masterData: 'Datos maestros',
        fullName: 'Nombre completo',
        language: 'Idioma',
        langDe: 'Alemán',
        langEn: 'Inglés',
        langEs: 'Español',
        langRu: 'Ruso',
        email: 'Correo electrónico',
        emailPlaceholder: 'opcional para Walk-In',
        phonePrimary: 'Teléfono (principal)',
        phoneSecondary: 'Teléfono (secundario)',
        dateOfBirth: 'Fecha de nacimiento (AAAA-MM-DD)',
        placeOfBirth: 'Lugar de nacimiento',
        nie: 'NIE',
        occupation: 'Profesión',
        street: 'Calle',
        postalCode: 'C.P.',
        city: 'Ciudad',
        country: 'País (ISO, p. ej. ES)',
        insurance: 'Seguro',
        familyDoctor: 'Médico de cabecera',
        doctorName: 'Nombre',
        doctorAddress: 'Dirección',
        doctorPhone: 'Teléfono',
        internalNotes: 'Notas internas',
        internalNotesPlaceholder: 'Visible solo en el panel — p. ej., indicaciones especiales sobre el paciente',
        possibleDuplicates: 'Posibles duplicados ({{count}})',
        duplicatesHint: 'Estos pacientes comparten nombre o número de teléfono. Revise y fusione si procede, para que todas las citas queden en un único registro.',
        mergeIntoThisTitle: 'Fusionar este paciente en {{name}}',
        mergeIntoThis: 'Fusionar en este',
        appointments: 'Citas ({{count}})',
        noAppointments: 'Aún no hay citas.',
        timelineBooked: 'Reservada',
        timelineRescheduled: 'Reprogramada',
        timelineCancelled: 'Cancelada',
        actorPatient: 'por el paciente',
        actorPractice: 'por la clínica',
        treatmentHistory: 'Historial de tratamientos',
        documents: 'Documentos ({{count}})',
        offer: 'Presupuesto',
        invoice: 'Factura',
        noDocuments: 'Aún no hay documentos.',
        draft: 'Borrador',
        due: 'vence',
        appointmentRef: 'Cita n.º {{id}}',
        openPdf: 'Abrir PDF',
        intake: 'Cuestionario',
        intakeFilled: 'Completado',
        intakeSubmittedAt: 'enviado {{date}}',
        toFormAndPdf: 'Al cuestionario + PDF',
        noIntake: 'Aún no se ha enviado ningún cuestionario.',
      },
    },
  },
};
